import { Modal } from '@breuni-ui/bdk-modal';
import { safeDefine } from '@breuni-ui/safe-define';
import { VSP_OPEN_EVENT, VspOpenEventDetail } from './vsp-event.js';

export { VSP_OPEN_EVENT };
export type { VspOpenEventDetail };

export class VspModal extends Modal {
  private readonly onOpen = (event: Event) => this.handleOpen(event as CustomEvent<VspOpenEventDetail>);

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(VSP_OPEN_EVENT, this.onOpen);
  }

  disconnectedCallback() {
    document.removeEventListener(VSP_OPEN_EVENT, this.onOpen);
    super.disconnectedCallback();
  }

  private async handleOpen(event: CustomEvent<VspOpenEventDetail>) {
    const { syan, colorId } = event.detail;

    const loader = this.querySelector('reco-vsp-loader');
    if (!loader) {
      return;
    }
    loader.setAttribute('syan', String(syan));
    loader.removeAttribute('color-id');
    await new Promise((resolve) => requestAnimationFrame(resolve));
    if (colorId) {
      loader.setAttribute('color-id', colorId);
      this.show();
    }
  }
}

safeDefine('ents-vsp-modal', VspModal);
